import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ICategory } from "../interfaces/category";
import { IFrequentlyQuestion } from "../interfaces/frequentlyQuestion";
import { IFinancialTransaction } from "../interfaces/financialTransaction";
import { IMessage } from "../interfaces/message";
import { IAppointment } from "../interfaces/appointment";
import { IBlog } from "../interfaces/blog";

@Injectable({
    providedIn: 'root',
})

export class FakeDataService {

    getDoctor() {
        return of([
            { id: 1, name: 'جعفر زارع', specialty: 'متخصص کلیه', pic: 'assets/img/team-1-800x800.jpg' },
            { id: 2, name: ' سارا ایزدی ', specialty: 'متخصص تغذیه', pic: 'assets/img/team-2-800x800.jpg' },
            { id: 3, name: 'زهرا ناصری', specialty: 'متخصص قلب', pic: 'assets/img/team-3-800x800.jpg' },
            { id: 2, name: ' سارا zsdf ', specialty: 'متخصص تغذیه', pic: 'assets/img/team-2-800x800.jpg' },
            { id: 3, name: 'زهرا dfhfth', specialty: 'متخصص قلب', pic: 'assets/img/team-3-800x800.jpg' },
            { id: 1, name: '55 زارع', specialty: 'متخصص کلیه', pic: 'assets/img/team-1-800x800.jpg' },
            { id: 1, name: '55 987', specialty: 'متخصص کلیه', pic: 'assets/img/team-3-800x800.jpg' },
        ]);
    }

    getQuestions(): Observable<IFrequentlyQuestion[]> {
        return of([
            { id: 1, question: 'Accordion Item 1', content: 'Content for item 1.' },
            { id: 2, question: 'Accordion Item 2', content: 'Content for item 2.' },
            { id: 3, question: 'Accordion Item 3', content: 'Content for item 3.' }

        ])
    }

    getCategories(): Observable<ICategory[]> {
        const items = [
            { id: 1, name: 'مغز و اعصاب', img: 'assets/img/brain-1.png' },
            { id: 2, name: 'قلب و عروق', img: 'assets/img/heart-2.png' },
            { id: 3, name: 'ریه', img: 'assets/img/lung-2.png' },
            { id: 4, name: 'بیماری های عفونی', img: 'assets/img/virus-1.png' },
            { id: 4, name: 'بیماری های قلبی', img: 'assets/img/heart-1.png' },

        ]

        return of(items)
    }

    getDates() {
        return of([
            { id: 1, day: 'شنبه', month: 'آذر', date: 1, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 2, day: 'یکشنبه', month: 'آذر', date: 2, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 3, day: 'دوشنبه', month: 'آذر', date: 3, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 4, day: 'سه شنبه', month: 'آذر', date: 4, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 5, day: 'چهارشنبه', month: 'آذر', date: 5, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 6, day: 'پنجشنبه', month: 'آذر', date: 6, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 7, day: 'جمعه', month: 'آذر', date: 7, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 8, day: 'شنبه', month: 'آذر', date: 8, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 9, day: 'یکشنبه', month: 'آذر', date: 9, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 10, day: 'دوشنبه', month: 'آذر', date: 10, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 11, day: 'سه شنبه', month: 'آذر', date: 11, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 12, day: 'چهارشنبه', month: 'آذر', date: 12, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 13, day: 'پنجشنبه', month: 'آذر', date: 13, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 14, day: 'جمعه', month: 'آذر', date: 14, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 15, day: 'شنبه', month: 'آذر', date: 15, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 16, day: 'یکشنبه', month: 'آذر', date: 16, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 17, day: 'دوشنبه', month: 'آذر', date: 17, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 18, day: 'سه شنبه', month: 'آذر', date: 18, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 19, day: 'چهارشنبه', month: 'آذر', date: 19, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 20, day: 'پنجشنبه', month: 'آذر', date: 20, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
            { id: 21, day: 'جمعه', month: 'آذر', date: 21, hours:['17:00', '18:00', '19:00', '20:00', '21:00', '22:00']},
        ])
    }

    getTransactions(): Observable<IFinancialTransaction[]> {
        return of([
            // {id: 1, date: 1733829144, doctor: 'احمد رضایی', category: 'عمومی', price: 199000, transactionId: 12563256, status: 1},
            // {id: 2, date: 1733829144, doctor: 'علی آقایی', category: 'قلب', price: 200000, transactionId: 12563256, status: 2},
            // {id: 3, date: 1733829144, doctor: 'ایمان یوسفی', category: 'جراحی', price: 167000, transactionId: 12563256, status: 3},
        ])
    }

    getMessages(): Observable<IMessage[]> {
        return of([
            // {id: 1, title: 'this is test', message: 'This is long message1', date: 1733829144, status: 1},
            // {id: 2, title: 'this is test', message: 'This is long message2', date: 1733829144, status: 2},
            // {id: 3, title: 'this is test', message: 'This is long message3', date: 1733829144, status: 2},
        ])
    }

    getAppointments(): Observable<IAppointment[]> {
        return of([
            // {id: 1, type: 'تصویری', date: 1733829144, status: 'پیش رو', doctor: 'علی آقایی', category: 'جراحی', price: 190000, link: 'https://test.medis.land'},
            // {id: 1, type: 'تلفنی', date: 1733829144, status: 'انجام شده', doctor: 'ایمان یوسفی', category: 'قلب', price: 190000, link: 'https://test.medis.land'},
        ])
    }

    getBlogs(): Observable<IBlog[]> {
        return of([
            {id: 1, title: 'دیابت و رژیم غذایی', img: 'assets/img/article-foods.jpg', createDate: 1733829144, authorPost: 'مانی حقیقی', category: 'تغذیه', tag: [], description: 'کربوهیدرات‌ها قند خون را سریع‌تر افزایش داده و بیش‌ترین تأثیر را روی قند خون شما دارند. مصرف فیبر، پروتئین و چربی ممکن است از افزایش قند خون بعد از غذا جلوگیری کنند. بنابراین باید در وعده‌های غذایی تنوع داشته باشید؛ مخلوطی از کربوهیدرات، پروتئین و چربی بخورید تا قند خون خود را بهتر مدیریت کرده و مدت بیشتری سیر بمانید.'},
            {id: 1, title: 'اضطراب و افسردگی و ارتباط آنها با یکدیگر.', img: 'assets/img/article-2.png', createDate: 1733829144, authorPost: 'ایمان اکبری', category: 'تغذیه', tag: [], description: 'کربوهیدرات‌ها قند خون را سریع‌تر افزایش داده و بیش‌ترین تأثیر را روی قند خون شما دارند. مصرف فیبر، پروتئین و چربی ممکن است از افزایش قند خون بعد از غذا جلوگیری کنند. بنابراین باید در وعده‌های غذایی تنوع داشته باشید؛ مخلوطی از کربوهیدرات، پروتئین و چربی بخورید تا قند خون خود را بهتر مدیریت کرده و مدت بیشتری سیر بمانید.'},
            {id: 1, title: 'اختلال دو قطبی چیست؟ راه های شناسایی آن؟', img: 'assets/img/article-3.png', createDate: 1733829144, authorPost: 'علی حقیقی', category: 'تغذیه', tag: [], description: 'کربوهیدرات‌ها قند خون را سریع‌تر افزایش داده و بیش‌ترین تأثیر را روی قند خون شما دارند. مصرف فیبر، پروتئین و چربی ممکن است از افزایش قند خون بعد از غذا جلوگیری کنند. بنابراین باید در وعده‌های غذایی تنوع داشته باشید؛ مخلوطی از کربوهیدرات، پروتئین و چربی بخورید تا قند خون خود را بهتر مدیریت کرده و مدت بیشتری سیر بمانید.'},
        ])
    }
}